import React, { ReactElement, CSSProperties } from "react"
import classname from "classnames"

import MDXLayout from "../../templates/mdx.layout"

import * as styles from "./container.module.css"

export const BackButton = ({
  goBack,
  className,
}: {
  goBack: () => void
  className?: string
}) => (
  <div onClick={goBack} className={classname(styles.goBack, className)}>
    ×
  </div>
)

export function Content({
  className,
  children,
}: {
  className?: string
  children: React.ReactElement
}) {
  return (
    <div className={className}>
      <MDXLayout>{children}</MDXLayout>
    </div>
  )
}

interface ContainerProp {
  goBack?: () => void
  title?: ReactElement
  showTitle?: boolean
  showTopBar?: boolean
  className?: string
  containerClassName?: string
  shadow?: boolean
  background?: string
  children?: ReactElement
  contentStyle?: CSSProperties
  noCut?: boolean
  showBack?: boolean
  scrollable?: boolean
  backClass?: string
}

export function Container({
  goBack,
  title,
  showTitle = true,
  className,
  showTopBar = true,
  containerClassName,
  background = "white",
  shadow = true,
  children,
  contentStyle,
  noCut = false,
  showBack = true,
  scrollable = false,
  backClass,
}: ContainerProp) {
  return (
    <div
      className={classname(
        styles.content,
        containerClassName,
        noCut ? styles.contentNoCut : ""
      )}
    >
      <div className={styles.background}>
        {!noCut && (
          <div
            className={classname(styles.cut, shadow ? styles.cutShadow : "")}
            style={{ borderBottom: `50px solid ${background}` }}
          ></div>
        )}
        <div
          style={{
            height: "100%",
            backgroundColor: background,
          }}
          className={styles.mainBackground}
        ></div>
      </div>
      {showTopBar && (
        <div className={styles.topBar}>
          {showTitle && <span className={styles.title}>{title}</span>}
        </div>
      )}
      {showBack && (
        <BackButton className={backClass} goBack={() => goBack?.()} />
      )}
      <div
        style={contentStyle}
        id="container"
        className={classname(
          styles.htmlContent,
          className,
          "fancy-scroll",
          scrollable ? styles.scrollableHtmlContent : ""
        )}
      >
        {children}
      </div>
    </div>
  )
}
